import { render, staticRenderFns } from "./BlockType1.vue?vue&type=template&id=b53496a2&scoped=true&"
import script from "./BlockType1.vue?vue&type=script&lang=ts&"
export * from "./BlockType1.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType1.vue?vue&type=style&index=0&id=b53496a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53496a2",
  null
  
)

export default component.exports